import React from "react";

import Right from "./Right";
import Panel from "./Panel";

import {asyncApi} from "./baseFunctions";

export default class ServerStatsPage extends React.Component {
	constructor()
	{
		super();
		this.int = false;
		this.loadChart = false;
		this.state = {
			hoverPoint: false,
			ignorePID: true,
			uptime: "",
			now: "",
			alert: [],
			processlist: [],
			load: [],
		};
	}

	componentWillMount(){
		this.getData();
		this.startInt();
	}
	componentWillUnmount()
	{
		if(this.int)
		{
			clearInterval(this.in);
		}
	}
	startInt = (val = 2500) => {
		console.log("Setting int to", val);
		if(this.int)
		{
			clearInterval(this.in);
		}
		this.int = setInterval(this.getData, val);
	}
	getData = async () => {
		let data = await asyncApi("POST", {"type": "serverStats"}, this.props.auth, 1);
		//console.log(data, this.state.load);
		let proccList = data.processlist.filter(proc => proc.cpu_percent > 0);
		if(this.state.ignorePID)
		{
			proccList = proccList.filter(data => data.name !== "glances"); //glances
		}
		this.setState({
			now: data.now,
			uptime: data.uptime,
			load: [
							...this.state.load,
							{
								now: Date.now(),
								value: proccList.reduce((a, b) => a + b.cpu_percent,0),
								proccList
							}
						],
			alert: data.alert,
			processlist: proccList.sort((a, b) => {
			  if (a.cpu_percent < b.cpu_percent) {
			    return 1;
			  }
			  if (a.cpu_percent > b.cpu_percent) {
			    return -1;
			  }
			  return 0;
			}),
		});
		requestAnimationFrame(() => this.drawLoad());
	}

	drawLoad = () => {
		var config = {
			type: 'line',
			data: {
				labels: this.state.load.map(data => {
					let date = new Date(data.now);
					let h = date.getHours();
					let m = date.getMinutes();
					let s = date.getSeconds();
					h = h < 10 ? "0" + h : h;
					m = m < 10 ? "0" + m : m;
					s = s < 10 ? "0" + s : s;
					return h + ":" + m + ":" + s;
				}),
				datasets: [{
					label: 'CPU Load',
					backgroundColor: "rgb(54, 162, 235)",
					borderColor: "rgb(54, 162, 235)",
					data: this.state.load.map(data => data.value),
					fill: false,
				}]
			},
			options: {
				animation: false,
				responsive: true,
				title: {
					display: true,
					text: 'Load'
				},
				tooltips: {
					mode: 'index',
					intersect: false,
				},
				hover: {
					mode: 'nearest',
					intersect: true
				},
				scales: {
					xAxes: [{
						display: true,
						scaleLabel: {
							display: true,
							labelString: 'Time'
						}
					}],
					yAxes: [{
						display: true,
						scaleLabel: {
							display: true,
							labelString: '%'
						}
					}]
				}
			}
		};
		var ctx = this.refs.chart.getContext('2d');
		if(this.loadChart)
		{
			this.loadChart.destroy();
		}
		this.loadChart = new window.Chart(ctx, config);

		this.refs.chart.onmousemove = (evt) => {
			var el = this.loadChart.getElementsAtXAxis(evt);
			if(el.length > 0 && this.state.hoverPoint !== el[0]._index)
			{
				this.setState({
					hoverPoint: el[0]._index
				});
			}
			//do something with the el object to display other information
			//elsewhere on the page
		};
	}
	render(){
		//console.log(this.state.hoverPoint, this.state.load);
		return (
			<Right title="Server" extraPanel={() => <div style={{display: "flex"}}>
					<select onChange={(e) => this.startInt(Number(e.target.value))} defaultValue="2500">
					<option value="600000">60s</option>
					<option value="30000">30s</option>
					<option value="10000">10s</option>
					<option value="5000">5s</option>
					<option value="2500">2.5s</option>
					<option value="1000">1s</option>
					<option value="500">500ms</option>
				</select>

				<div>
					<input type="checkbox" value="1" defaultChecked={true} id="PID" onChange={(e) => this.setState({ignorePID: e.target.checked})}/> <label htmlFor="PID">Ignore 'glances' PID</label>
				</div>
				</div>}>
      
				<Panel title="Oversigt">
					Up time {this.state.uptime}, last update {this.state.now}
				</Panel>

				<Panel title="CPU Load" size="custom" custom="9"
						customIcons={() => <button onClick={() => {
							this.setState({load: []});
							requestAnimationFrame(() => {
								this.drawLoad();
								this.getData();
							});
						}}>Clear</button>}
				>
					<canvas ref="chart" style={{height: 100}}></canvas>
				</Panel>
				<Panel size="custom" custom="3" key={this.state.hoverPoint}>
					<table className="table table-striped jambo_table bulk_action dataTable no-footer">
						<thead>
							<tr>
								<th>Name</th>
								<th>%</th>
							</tr>
						</thead>
						<tbody>
							{
								typeof this.state.hoverPoint === "number" ? 
									this.state.load[this.state.hoverPoint].proccList.map((proc, key) => <tr key={key}>
										<td>{proc.name}</td>
										<td>{proc.cpu_percent}</td>
									</tr>)
								: null
							}
						</tbody>
					</table>
				</Panel>
				<Panel title="Proccess > 0%">
					<table className="table table-striped jambo_table bulk_action dataTable no-footer">
						<thead>
							<tr>
								<th>Name</th>
								<th>%</th>
							</tr>
						</thead>
						<tbody>
							{
								this.state.processlist.map((proc, key) => <tr key={key}>
									<td>{proc.name}</td>
									<td>{proc.cpu_percent}</td>
								</tr>)
							}
						</tbody>
					</table>
				</Panel>
			</Right>);
	}
}


// WEBPACK FOOTER //
// ./src/components/ServerStatsPage.js